(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    let last = window.scrollY;
    let queued = false;

    const update = () => {
      queued = false;
      const header = document.querySelector('.sa-header[data-autohide]');
      if (!header) return;
      const y = window.scrollY;
      // Past the home page's opening pair, the lockup's "works with Shopify" comes back (see the CSS).
      header.classList.toggle('is-down', y >= window.innerHeight * 0.5);
      if (y < 100) {
        header.classList.remove('is-hidden');
        last = y;
      } else if (y > last + 10) {
        header.classList.add('is-hidden');
        last = y;
      } else if (y < last - 10) {
        header.classList.remove('is-hidden');
        last = y;
      }
    };

    window.addEventListener(
      'scroll',
      () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(update);
      },
      { passive: true }
    );
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-cart"]) return;
  try {
    
  /*
   * <sa-cart-call>: the cart's "Where should Alex call?" block. Check out is
   * never disabled for it: pressed before the number is valid E.164 and the
   * box is ticked, the submit is stopped, each problem shows its error (the
   * number's under the field, the tick's under the box), the line above
   * Check out says what is needed, and focus goes to the first problem. The
   * demo guide ignores a submit stopped this way, so it stays at its step.
   * While typing, the number's error only clears; a new one waits for the
   * field to be committed. The details are saved to the cart through
   * /cart/update.js as they change, then the demo guide is told
   * (sa:cart-attributes on document, with the cart). A failed save is only
   * logged: the checkout POST sends the same attributes anyway. The hint's
   * example, and the error's, follow the browser's region (en-GB, en-AU), US
   * otherwise. A saved E.164 number is shown spaced for reading; clean()
   * posts it as E.164 again. At the guide's step 5 (data-sa-step="5" on
   * <html>, back from checkout) the number and the tick are read-only: the
   * call is booked to that number already.
   */
  (() => {
    const E164 = /^\+[1-9]\d{7,14}$/;
    const clean = (raw) => {
      const v = String(raw || '')
        .trim()
        .replace(/\(0\)/g, '')
        .replace(/[^\d+]/g, '');
      return v.startsWith('00') ? `+${v.slice(2)}` : v;
    };

    class SaCartCall extends HTMLElement {
      connectedCallback() {
        if (this.form) return;
        const form = this.closest('form');
        const phone = this.querySelector('input[type="tel"]');
        const consent = this.querySelector('input[type="checkbox"]');
        const button = form && form.querySelector('[name="checkout"]');
        if (!form || !phone || !consent || !button) return;
        Object.assign(this, { form, phone, consent, button });
        this.gate = document.getElementById(this.dataset.gate);
        this.blocked = button.hasAttribute('data-blocked');

        // The script does the stricter check, so the browser's pattern and bubbles step aside,
        // and Check out stops looking disabled (the :has rule is for no JavaScript only).
        form.noValidate = true;
        form.setAttribute('data-sa-live', '');
        phone.removeAttribute('pattern');

        // An example number from the visitor's own region, when there is one for it, in the field, the hint and the error.
        const region = String(navigator.language || '').split('-')[1];
        this.example = (region && this.getAttribute(`data-example-${region.toLowerCase()}`)) || this.dataset.example || '';
        const example = this.querySelector('[data-sa-example]');
        if (example && this.example) example.textContent = this.example;
        if (this.example) phone.placeholder = this.example;

        // A saved number, which the cart holds as E.164, reads as it was typed.
        phone.value = phone.value
          .replace(/^\+1(\d{3})(\d{3})(\d{4})$/, '+1 $1 $2 $3')
          .replace(/^\+44(7\d{3})(\d{6})$/, '+44 $1 $2')
          .replace(/^\+61(4\d{2})(\d{3})(\d{3})$/, '+61 $1 $2 $3');

        // Back from checkout, the call is booked to this number: shown, not edited, until the guide starts again.
        const root = document.documentElement;
        const lock = () => {
          const done = root.dataset.saStep === '5';
          phone.readOnly = done;
          if (done) consent.setAttribute('aria-readonly', 'true');
          else consent.removeAttribute('aria-readonly');
        };
        consent.addEventListener('click', (event) => {
          if (phone.readOnly) event.preventDefault();
        });
        new MutationObserver(lock).observe(root, { attributes: true, attributeFilter: ['data-sa-step'] });
        lock();

        phone.addEventListener('input', () => {
          this.sync();
          this.check(false);
        });
        phone.addEventListener('change', () => {
          this.check(true);
          this.save();
        });
        consent.addEventListener('change', () => {
          this.sync();
          this.tick(false);
          this.save();
        });
        form.addEventListener('submit', (event) => this.submit(event));
        window.addEventListener('pageshow', (event) => {
          this.sync();
          if (event.persisted) this.callStatus();
        });

        this.sync();
        this.callStatus();
        if (phone.value.trim()) this.check(true);
      }

      valid() {
        return E164.test(clean(this.phone.value));
      }

      ready() {
        return this.valid() && this.consent.checked;
      }

      /*
       * Back from checkout: asks the webhook whether this run's call is booked
       * and, once it is, shows when. Only the cart token's first part is sent,
       * never its key. No answer leaves the countdown as it is.
       */
      async callStatus() {
        const card = document.querySelector('.sa-cart__back');
        if (!card || !this.dataset.callUrl || this.asking) return;
        let state = null;
        try {
          state = JSON.parse(localStorage.getItem('sa-demo-guide') || 'null');
        } catch (err) {
          return;
        }
        if (!state || state.step !== 5) return;
        const run = String(state.at);
        // Already showing this run's call. A booking from an earlier run on this page goes first.
        if (card.dataset.saCall && card.dataset.saCallRun === run) return;
        this.clearCall(card);
        this.asking = true;
        try {
          const response = await fetch(this.dataset.cartJs, { headers: { Accept: 'application/json' } });
          const cart = response.ok ? await response.json() : {};
          const token = String(cart.token || '').split('?')[0];
          if (!token) return;
          const runParam = /^\d{1,16}$/.test(run) ? `&run=${run}` : '';
          const url = `${this.dataset.callUrl}&shop=${encodeURIComponent(this.dataset.shop || '')}&cart=${encodeURIComponent(token)}${runParam}`;
          // Every ask says the visitor is back, so the webhook rings them now. Only the first used to,
          // and Shopify's checkout event often lands after it, so the call waited for its booked time.
          const back = '&back=1';
          // Shopify's checkout event usually lands within seconds; ask every 5 for a minute.
          for (let i = 0; i < 12; i++) {
            if (i) await new Promise((resolve) => setTimeout(resolve, 5000));
            const res = await fetch(url + back, { cache: 'no-store' }).catch(() => null);
            const body = res && res.ok ? await res.json().catch(() => null) : null;
            if (body && body.state === 'queued' && body.at) {
              this.showCall(card, body.at, run);
              break;
            }
          }
        } catch (err) {
          console.debug('sa-cart: call status unavailable', err);
        } finally {
          this.asking = false;
        }
      }

      /*
       * "Alex calls at 20:31.", or "at 08:00 on Monday" when it is not today,
       * in the visitor's own time. Shown only while the call is ahead: three
       * minutes after its time the guide's countdown lines come back, so a
       * call that never arrived gets the "No call yet?" line.
       */
      showCall(card, at, run) {
        const when = new Date(at).getTime();
        const slot = card.querySelector('[data-sa-call-at]');
        const line = card.querySelector('[data-sa-call-line]');
        if (Number.isNaN(when) || !slot || !line || when < Date.now() - 60e3) return;
        let text = new Date(when).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        if (new Date(when).toDateString() !== new Date().toDateString()) {
          text += ` on ${new Date(when).toLocaleDateString('en-GB', { weekday: 'long' })}`;
        }
        // Shown first and filled on the next frame, so screen readers announce it.
        line.hidden = false;
        requestAnimationFrame(() => {
          slot.textContent = text;
        });
        card.dataset.saCall = 'queued';
        card.dataset.saCallRun = run;
        clearTimeout(this.callTimer);
        this.callTimer = setTimeout(() => this.clearCall(card), when + 180e3 - Date.now());
      }

      clearCall(card) {
        clearTimeout(this.callTimer);
        delete card.dataset.saCall;
        delete card.dataset.saCallRun;
        const line = card.querySelector('[data-sa-call-line]');
        const slot = card.querySelector('[data-sa-call-at]');
        if (line) line.hidden = true;
        if (slot) slot.textContent = '';
      }

      /* Once both details are in, a line left by a blocked press goes (or becomes the ready line, if one is set). */
      sync() {
        if (!this.gate || !this.ready()) return;
        const message = this.dataset.msgReady || '';
        if (this.gate.textContent !== message) this.gate.textContent = message;
      }

      /* While typing, an error only clears; a new one waits for the field to be committed, or a press (all). */
      check(committed, all = false) {
        const bad = (all || this.phone.value.trim() !== '') && !this.valid();
        if (bad && !committed) return;
        const output = document.getElementById(`${this.phone.id}-error`);
        const message = bad ? (this.dataset.msgInvalid || '').replace('[example]', this.example) : '';
        if (output && output.textContent !== message) output.textContent = message;
        if (bad) this.phone.setAttribute('aria-invalid', 'true');
        else this.phone.removeAttribute('aria-invalid');
      }

      /* The tick's error: shown only when a press finds the box empty, cleared once it is ticked. */
      tick(pressed) {
        const bad = pressed && !this.consent.checked;
        if (!bad && !this.consent.hasAttribute('aria-invalid')) return;
        const output = document.getElementById(`${this.consent.id}-error`);
        const message = bad ? this.dataset.msgConsent || '' : '';
        if (output && output.textContent !== message) output.textContent = message;
        if (bad) this.consent.setAttribute('aria-invalid', 'true');
        else this.consent.removeAttribute('aria-invalid');
      }

      save() {
        clearTimeout(this.timer);
        this.timer = setTimeout(async () => {
          const number = clean(this.phone.value);
          const attributes = {
            'Call me about this cart': this.consent.checked ? this.consent.value : '',
            _sa_demo: '1',
            _sa_consent_version: this.dataset.consentVersion,
          };
          // Never store a number that fails the check. An empty field clears the old one.
          if (!number || E164.test(number)) attributes['Mobile number'] = number;
          try {
            const response = await fetch(this.dataset.updateUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ attributes }),
            });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const cart = await response.json();
            document.dispatchEvent(new CustomEvent('sa:cart-attributes', { detail: cart }));
          } catch (error) {
            console.debug('sa-cart: the call details were not saved yet; checkout sends them', error);
          }
        }, 300);
      }

      submit(event) {
        if (event.submitter && event.submitter.name !== 'checkout') return;
        if (this.blocked) return;
        if (!this.ready()) {
          // Stopped here, so the guide (which ignores a prevented submit) stays at its step.
          event.preventDefault();
          const number = this.valid();
          this.check(true, true);
          this.tick(true);
          if (this.gate) {
            // Emptied first, so a second blocked press is announced again.
            this.gate.textContent = '';
            requestAnimationFrame(() => {
              this.gate.textContent = this.dataset.msgNeeded || '';
            });
          }
          (number ? this.consent : this.phone).focus();
          return;
        }
        this.phone.value = clean(this.phone.value);
      }
    }

    if (!customElements.get('sa-cart-call')) customElements.define('sa-cart-call', SaCartCall);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:block:select', (event) => {
    const item = event.target;
    if (item instanceof HTMLDetailsElement && item.classList.contains('sa-faq__item')) {
      item.open = true;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
